import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-select" }


import QSelect from 'quasar/src/components/select/QSelect.js';;
import { PropType, ref, computed } from 'vue';
import { actionHandler } from '~actions/actionHandler';
import {
  Action, ISearchFromBackend, ITable, TableRow,
} from '@/components/TableComponent/types';
import { arrayUnique } from '@/components/TableComponent/helpers';

const __default__ = {
  name: 'SearchSelect',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String as PropType<string>,
    default: () => '',
  },
  field: {
    type: String as PropType<string>,
    default: () => '',
  },
  label: {
    type: String as PropType<string>,
  },
  options: {
    type: Array as PropType<TableRow[]>,
    default: () => [],
  },
  searchFromBackend: {
    type: Object as PropType<ISearchFromBackend>,
  },
  filter: {
    type: Boolean as PropType<boolean>,
    default: () => true,
  },
},
  emits: ['select', 'filter', 'blur'],
  setup(__props, { emit }) {

const props = __props






const selectedValue = ref(null);

const _options = ref(props.options);

const isTemp = computed(() => (id: number) => {
  if (id) {
    const fi = props.options.find((i: TableRow) => i[props.id] === id);
    if (fi) return false;
  }
  return true;
});

const applyFilter = (needle: string) => {
  _options.value = _options.value.filter((v) => {
    if (v[props.field]) {
      return v[props.field].toLowerCase().indexOf(needle) > -1;
    }
    return false;
  });
};

const blurFn = () => {
  emit('blur');
  _options.value = props.options;
};

const filterFn = async (val: string, update: any) => {
  if (val === '') {
    update(() => {
      _options.value = props.options;
    });
    return;
  }

  update(async () => {
    const needle = val.toLowerCase();
    if (props.filter) {
      emit('filter', { needle, field: props.field });
    }
    const innerFilnter = _options.value.filter(
      (i) => i[props.field].toLowerCase().includes(needle),
    );
    if (props.searchFromBackend && val.length >= props.searchFromBackend.min_length) {
      const searchAction = {
        ...props.searchFromBackend.action,
        customParam: JSON.stringify({
          text: needle,
        }),
      } as Action;
      const addData = await actionHandler(searchAction) as ITable;
      if (addData && typeof addData !== 'boolean') {
        _options.value = arrayUnique(innerFilnter.concat(addData.data), props.id);
        applyFilter(needle);
        return;
      }
    }
    applyFilter(needle);
  });
};

const select = () => {
  emit('select', selectedValue.value);
};


return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(QSelect), {
      dense: "",
      outlined: "",
      modelValue: selectedValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
        select
      ],
      label: __props.label,
      options: _options.value,
      "option-value": __props.id,
      "option-label": __props.field,
      "use-input": "",
      "input-debounce": "1000",
      onFilter: filterFn,
      onBlur: blurFn,
      style: {"width":"250px"},
      behavior: "menu"
    }, {
      option: _withCtx((scope) => [
        _createVNode(_component_q_item, _mergeProps(scope.itemProps, { dense: "" }), {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, {
              class: _normalizeClass({
              'text-teal-8': _unref(isTemp)(scope.opt[props.id]),
            })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.opt[props.field]), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class"]),
            (_unref(isTemp)(scope.opt[props.id]))
              ? (_openBlock(), _createBlock(_component_q_item_section, {
                  key: 0,
                  side: "",
                  class: "text-teal-8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "playlist_add" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["modelValue", "label", "options", "option-value", "option-label"])
  ]))
}
}

})